module.exports = __webpack_public_path__ + "static/media/Front-Lower-Limb(R) v2.445f7d17.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Front-Lower-Limb(R) v2.png
// module id = 413
// module chunks = 0